import { ACTION_TYPE, GETTER_TYPE, MUTATION_TYPE } from './types'
import statsApi from '@/api/statistics'

export default {
  state: {
    statsStudentsToPartners: [],
    statsClassesStudentsDistribution: [],
    statsOlympicsResults: [],
    statsCountSchoolsDOClasses: []
  },
  mutations: {
    [MUTATION_TYPE.setStatsStudentsToPartners]:
      (state, statsStudentsToPartners) => {
        state.statsStudentsToPartners = statsStudentsToPartners
      },

    [MUTATION_TYPE.setStatsCountSchoolsDOClasses]:
      (state, statsCountSchoolsDOClasses) => {
        state.statsCountSchoolsDOClasses = statsCountSchoolsDOClasses
      },

    [MUTATION_TYPE.setStatsClassesStudentsDistribution]:
      (state, statsClassesStudentsDistribution) => {
        state.statsClassesStudentsDistribution = statsClassesStudentsDistribution
      },

    [MUTATION_TYPE.setStatsOlympicsResults]:
      (state, statsOlympicsResults) => {
        state.statsOlympicsResults = statsOlympicsResults
      }
  },
  actions: {
    [ACTION_TYPE.fetchStatsStudentsToPartners]:
      async ({ commit }) => new Promise((resolve, reject) => {
        statsApi.getStatsStudentsToPartners().then((response) => {
          commit(MUTATION_TYPE.setStatsStudentsToPartners, response.data)
          resolve()
        }).catch((error) => {
          reject(error)
        })
      }),

    [ACTION_TYPE.updateStatsStudentsToPartners]:
      async ({ commit }, studentsToPartners) => new Promise((resolve, reject) => {
        statsApi.postStatsStudentsToPartners(studentsToPartners)
          .then((response) => {
            commit(MUTATION_TYPE.setStatsStudentsToPartners, response.data)
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
      }),

    [ACTION_TYPE.fetchStatsCountSchoolsDOClasses]:
      async ({ commit }) => new Promise((resolve, reject) => {
        statsApi.getCountSchoolsDOClasses().then((response) => {
          commit(MUTATION_TYPE.setStatsCountSchoolsDOClasses, response.data)
          resolve()
        }).catch((error) => {
          reject(error)
        })
      }),

    [ACTION_TYPE.updateStatsCountSchoolsDOClasses]:
      async ({ commit }, countSchoolsDOClasses) => new Promise((resolve, reject) => {
        statsApi.postCountSchoolsDOClasses(countSchoolsDOClasses)
          .then((response) => {
            commit(MUTATION_TYPE.setStatsCountSchoolsDOClasses, response.data)
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
      }),

    [ACTION_TYPE.fetchStatsClassesStudentsDistribution]:
      async ({ commit }) => new Promise((resolve, reject) => {
        statsApi.getClassesStudentsDistribution().then((response) => {
          commit(MUTATION_TYPE.setStatsClassesStudentsDistribution, response.data)
          resolve()
        }).catch((error) => {
          reject(error)
        })
      }),

    [ACTION_TYPE.updateStatsClassesStudentsDistribution]:
      async ({ commit }, countClassesStudentsDistribution) => new Promise((resolve, reject) => {
        statsApi.postClassesStudentsDistribution(countClassesStudentsDistribution)
          .then((response) => {
            commit(MUTATION_TYPE.setStatsClassesStudentsDistribution, response.data)
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
      }),

    [ACTION_TYPE.fetchStatsOlympicsResults]:
      async ({ commit }, id) => new Promise((resolve, reject) => {
        statsApi.getStatsOlympicsResults(id).then((response) => {
          commit(MUTATION_TYPE.setStatsOlympicsResults, response.data)
          resolve()
        }).catch((error) => {
          reject(error)
        })
      }),

    [ACTION_TYPE.updateStatsOlympicsResults]:
      async ({ commit }, newStats) => new Promise((resolve, reject) => {
        statsApi.postStatsOlympicsResults(newStats).then(() => {
          commit(MUTATION_TYPE.setStatsOlympicsResults, newStats.newData)
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
  },
  getters: {
    [GETTER_TYPE.getStatsStudentsToPartners]:
      (state) => state.statsStudentsToPartners,

    [GETTER_TYPE.getStatsCountSchoolsDOClasses]:
      (state) => state.statsCountSchoolsDOClasses,

    [GETTER_TYPE.getStatsClassesStudentsDistribution]:
      (state) => state.statsClassesStudentsDistribution,

    [GETTER_TYPE.getStatsOlympicsResults]:
      (state) => state.statsOlympicsResults
  }
}
